import boxShadow from "assets/theme/functions/boxShadow";
import colors from "assets/theme/base/colors";

const { tabs } = colors;

const boxShadows = {
  xs: "0 1px 2px 0 rgba(28, 25, 23, 0.05)",
  sm: "0 1px 3px 0 rgba(28, 25, 23, 0.1), 0 1px 2px -1px rgba(28, 25, 23, 0.1)",
  md: "0 4px 6px -1px rgba(28, 25, 23, 0.1), 0 2px 4px -2px rgba(28, 25, 23, 0.1)",
  lg: "0 10px 15px -3px rgba(28, 25, 23, 0.1), 0 4px 6px -4px rgba(28, 25, 23, 0.1)",
  xl: "0 20px 25px -5px rgba(28, 25, 23, 0.1), 0 8px 10px -6px rgba(28, 25, 23, 0.1)",
  xxl: "0 25px 50px -12px rgba(28, 25, 23, 0.25)",
  inset: "inset 0 2px 4px 0 rgba(28, 25, 23, 0.05)",

  colored: {
    primary: "0 4px 14px 0 rgba(13, 148, 136, 0.25)",
    info: "0 4px 14px 0 rgba(14, 165, 233, 0.25)",
    success: "0 4px 14px 0 rgba(34, 197, 94, 0.25)",
    warning: "0 4px 14px 0 rgba(245, 158, 11, 0.25)",
    error: "0 4px 14px 0 rgba(239, 68, 68, 0.25)",
  },

  navbarBoxShadow: "0 1px 3px 0 rgba(28, 25, 23, 0.1), 0 1px 2px -1px rgba(28, 25, 23, 0.1)",
  sliderBoxShadow: { thumb: "0 1px 3px 0 rgba(28, 25, 23, 0.2)" },
  tabsBoxShadow: { indicator: boxShadow([0, 1], [5, 1], tabs.indicator.boxShadow, 1) },
};

export default boxShadows;
